/**
 * Payment constants — single source of truth (frontend).
 *
 * Mirrors backend/constants/paymentMethods.js. Consumed by the Add Payment
 * modal, bulk import, Customer 360 filters, analytics and any dropdown that
 * needs payment method / status options.
 *
 * Values must stay in sync with the backend enum.
 */

export const PAYMENT_METHOD_CODES = [
  'CASH',
  'CHEQUE',
  'UPI',
  'CARD',
  'BANK_TRANSFER',
  'NEFT',
  'RTGS',
  'IMPS',
  'OTHER'
];

export const PAYMENT_METHOD_LABELS = {
  CASH: 'Cash',
  CHEQUE: 'Cheque',
  UPI: 'UPI',
  CARD: 'Card',
  BANK_TRANSFER: 'Bank Transfer',
  NEFT: 'NEFT',
  RTGS: 'RTGS',
  IMPS: 'IMPS',
  OTHER: 'Other'
};

/** [{ value, label }] — for form dropdowns (Add Payment, Bulk Import). */
export const PAYMENT_METHODS = PAYMENT_METHOD_CODES.map((value) => ({
  value,
  label: PAYMENT_METHOD_LABELS[value]
}));

/** [{ value, label }] with a leading "All Methods" — for filters. */
export const PAYMENT_METHOD_FILTER_OPTIONS = [
  { value: '', label: 'All Methods' },
  ...PAYMENT_METHODS
];

export const PAYMENT_STATUSES = ['PENDING', 'PARTIAL', 'PAID'];

export const PAYMENT_STATUS_FILTER_OPTIONS = [
  { value: '', label: 'All Statuses' },
  { value: 'PENDING', label: 'Pending' },
  { value: 'PARTIAL', label: 'Partial' },
  { value: 'PAID', label: 'Paid' }
];

/** Human-friendly label for a payment method code. */
export const formatPaymentMethodLabel = (method) => {
  if (!method) return '--';
  return PAYMENT_METHOD_LABELS[method] || String(method).replace(/_/g, ' ');
};
